export default __webpack_public_path__ + "assets/images/e76a9cfbb0a654b790d5578dfa4e8cec.svg";